import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/treshold-5.svg")